import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";
import moment from "moment";


export default class LoginRecords extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Accounts_Logins._name, API.RequestType.READ_ALL);
		super(props, model);

	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		if (this.props.onDataLoaded && prevState.data !== this.state.data) {
			this.props.onDataLoaded(this.state.data || []);
		}
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Email",
				id: "email",
				accessor: obj => (obj.email)
			},
			{
				Header: "User",
				id: "user",
				width: 80,
				accessor: obj => (obj.user) ? 'User' : 'Owner',
			},
			{
				Header: "Date",
				id: "date",
				width: 175,
				accessor: obj => obj.date ? moment(obj.date).local().format("MM/DD/YYYY h:mm A") : '-'
			},
			{
				Header: "Login Success",
				id: "success",
				width: 100,
				accessor: obj => obj.success,
				Cell: props => {
					const success = props.value === true || props.value === 1 || props.value === "1";
					return (
						<span style={{color: success ? "#2e7d32" : "#c62828", fontWeight: 600}}>
							{success ? "Success" : "Failed"}
						</span>
					);
				}
			},
			{
				Header: "IP Address",
				id: "ip",
				width: 125,
				accessor: obj => (obj.ip)
			},
			// {
			// 	Header: "Location",
			// 	id: "location",
			// 	accessor: obj => (obj.location)
			// },
			{
				Header: "GEO Coordinates",
				id: "geo",
				accessor: obj => (obj.geo)
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Login Records', "")}
							{this.renderHeaderRight("Login Records", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
